import { Container, Typography, Button, Box, Grid } from "@mui/material";
import { useAuth } from "../../providers/AuthenticationProvider";
import XseeLogo from "../../assets/logo.png"; // Import your Xsee logo image
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "../../providers/SnackbarProvider";
import ComputerIcon from "@mui/icons-material/Computer";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import Diversity1Icon from "@mui/icons-material/Diversity1";
import { useState } from "react";
import AccordionPay from "../../components/affiliate/AccordionPay";
import TelegramIcon from "@mui/icons-material/Telegram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { FooterAll } from "../../components/FooterAll";
import { useNetwork } from "../../providers/NetworkProvider";

export const UserDashboard = () => {
	const [cardSelect, setcardSelect] = useState(0);
	const { t } = useTranslation();
	const { userSubscription, traderProfile, profile, logout } = useAuth();
	const { makePost } = useNetwork();
	function redirect(url: string) {
		window.location.href = url;
	}
	const navigate = useNavigate();
	return (
		<>
			<Container sx={{ mt: 12 }}>
				<Grid container spacing={0}>
					<Grid
						md={12}
						xs={12}
						sx={{
							padding: "0 20px 20px 20px",
							mt: 2,
						}}
					>
						<Typography
							variant="h4"
							sx={{
								fontFamily: "Work Sans !important",
								fontWeight: "bold",
								fontSize:
									window.innerWidth < 600 ? "24px" : "28px",
							}}
						>
							{t("userDashboard.welcome")}
						</Typography>
						<Typography
							sx={{
								fontFamily: "Work Sans !important",
							}}
						>
							Current plan:{" "}
							<b>
								{!userSubscription?.planId
									? "No Plan"
									: userSubscription?.planId}{" "}
							</b>
						</Typography>
					</Grid>
				</Grid>

				<Grid container spacing={0}>
					<Grid
						md={12}
						xs={12}
						sx={{
							padding: "0 20px 20px 20px",
							mt: 2,
						}}
					>
						<Box className="card">
							{cardSelect == 0 ? (
								<AccordionPay />
							) : (
								// <>Coming soon</>
								// <div
								// 	style={{
								// 		display: "flex",
								// 		flexDirection: "column",
								// 		alignItems: "center",
								// 		justifyContent: "center",
								// 		gap: 2,
								// 	}}
								// >
								// 	<Typography
								// 		variant="h3"
								// 		sx={{
								// 			fontFamily: "Work Sans !important",
								// 			fontWeight: "bold",
								// 			fontSize:
								// 				window.innerWidth < 600
								// 					? "24px"
								// 					: "38px",
								// 		}}
								// 	>
								// 		{t("userDashboard.lunchtext")}
								// 	</Typography>
								// 	<Typography
								// 		sx={{
								// 			marginBottom: "16px",
								// 			fontFamily: "Work Sans !important",
								// 			fontSize:
								// 				window.innerWidth < 600
								// 					? "16px"
								// 					: "24",
								// 		}}
								// 	>
								// 		{t("userDashboard.lunchtextsub")}
								// 	</Typography>
								// </div>
								<>
									<Typography
										variant="h4"
										sx={{
											fontFamily: "Work Sans !important",
											fontWeight: "bold",
											fontSize:
												window.innerWidth < 600
													? "24px"
													: "28px",
										}}
									>
										{t(
											"userDashboard.becomeAffiliate.title"
										)}
									</Typography>
									<Typography
										sx={{
											fontFamily: "Work Sans !important",
											marginBottom: "16px",
										}}
									>
										{t(
											"userDashboard.becomeAffiliate.text"
										)}
									</Typography>

									<Button
										variant="contained"
										color="primary"
										startIcon={<TelegramIcon />}
										sx={{
											textTransform: "none",
											margin: "16px 10px 8px 0",
											fontWeight: "600",
											borderRadius: "100px",
										}}
										onClick={() => {
											redirect("");
										}}
									>
										Telegram
									</Button>

									<Button
										variant="contained"
										color="secondary"
										startIcon={<WhatsAppIcon />}
										sx={{
											textTransform: "none",
											margin: "16px 0 8px 0",
											fontWeight: "600",
											borderRadius: "100px",
										}}
										onClick={() => {
											redirect("");
										}}
									>
										Whatsapp
									</Button>
								</>
							)}
						</Box>
					</Grid>
				</Grid>

				<Grid container spacing={0}>
					<Grid
						md={4}
						xs={12}
						sx={{
							padding: "20px",
						}}
					>
						<Box
							className={
								cardSelect == 0 ? "card bg-green" : "card"
							}
						>
							<div className="titleCard">
								{t("userDashboard.upgrada.title")}
							</div>
							<div className="textCard">
								{t("userDashboard.upgrada.text")}
							</div>
							<Button
								variant="contained"
								color={
									cardSelect == 0 ? "primary" : "secondary"
								}
								startIcon={<RocketLaunchIcon />}
								sx={{
									textTransform: "none",
									margin: "16px 0 8px 0",
									fontWeight: "600",
									borderRadius: "100px",
								}}
								onClick={() => {
									setcardSelect(0);
								}}
							>
								{t("userDashboard.upgrada.button")}
							</Button>
						</Box>
					</Grid>

					<Grid
						md={4}
						xs={12}
						sx={{
							padding: "20px",
						}}
					>
						<Box
							className={
								cardSelect == 1 ? "card bg-green" : "card"
							}
						>
							<div className="titleCard">
								{profile != null &&
								profile.role != null &&
								profile.role === "Affiliate"
									? t(
											"userDashboard.becomeAffiliate.title.alreadyAnAffiliate"
									  )
									: t("userDashboard.becomeAffiliate.title")}
							</div>
							<div className="textCard">
								{profile != null &&
								profile.role != null &&
								profile.role === "Affiliate"
									? t(
											"userDashboard.becomeAffiliate.text.alreadyAnAffiliate"
									  )
									: t("userDashboard.becomeAffiliate.text")}
							</div>

							<Button
								variant="contained"
								color={
									cardSelect == 1 ? "primary" : "secondary"
								}
								startIcon={<Diversity1Icon />}
								sx={{
									textTransform: "none",
									margin: "16px 0 8px 0",
									fontWeight: "600",
									borderRadius: "100px",
								}}
								onClick={() => {
									if (
										profile != null &&
										profile.role != null &&
										profile.role === "Affiliate"
									) {
										navigate("/affiliate/dashboard");
									} else {
										setcardSelect(1);
										// navigate("/reserved/become-trader");
									}
								}}
							>
								{profile != null &&
								profile.role != null &&
								profile.role === "Affiliate"
									? t(
											"userDashboard.becomeAffiliate.button.alreadyAnAffiliate"
									  )
									: t("userDashboard.becomeAffiliate.button")}
							</Button>
						</Box>
					</Grid>

					<Grid
						md={4}
						xs={12}
						sx={{
							padding: "20px",
						}}
					>
						<Box
							className={
								cardSelect == 2 ? "card bg-green" : "card"
							}
						>
							<div className="titleCard">
								{traderProfile != null
									? t(
											"userDashboard.becomeTrader.title.alreadyATrader"
									  )
									: t("userDashboard.becomeTrader.title")}
							</div>
							<div className="textCard">
								{traderProfile != null
									? t(
											"userDashboard.becomeTrader.text.alreadyATrader"
									  )
									: t("userDashboard.becomeTrader.text")}
							</div>

							<Button
								variant="contained"
								color="secondary"
								startIcon={<ComputerIcon />}
								sx={{
									textTransform: "none",
									margin: "16px 0 8px 0",
									fontWeight: "600",
									borderRadius: "100px",
								}}
								onClick={() => {
									if (traderProfile != null) {
										navigate("/trader/profile");
									} else {
										// setcardSelect(2);
										navigate("/reserved/become-trader");
									}
								}}
							>
								{traderProfile != null
									? t(
											"userDashboard.becomeTrader.button.alreadyATrader"
									  )
									: t("userDashboard.becomeTrader.button")}
							</Button>
						</Box>
					</Grid>
				</Grid>
			</Container>
			<Container
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					paddingTop: "20px",
					marginBottom: "-40px",
					gap: "16px",
					marginTop: "20px",
				}}
			>
				<Button
					sx={{
						textTransform: "none",
						fontWeight: "300",
						color: "grey",
						fontSize: 12,
					}}
					onClick={async () => {
						if (profile == null) return;
						const res = await makePost(
							"payments/stripe/stripeBillingSession",
							{
								customerId: profile.customerId,
							}
						);
						const url = res.data.url;
						redirect(url);
					}}
				>
					{t("userDashboard.manageSubscription")}
				</Button>
				<Button
					sx={{
						textTransform: "none",
						fontWeight: "300",
						color: "grey",
						fontSize: 12,
					}}
					onClick={async () => {
						await logout();
					}}
				>
					Logout
				</Button>
			</Container>

			<FooterAll />
		</>
	);
};
